import { Col, Divider, Row, Spin } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import historyBookingAPI from '~/api/HistoryBooking';
import { SVGS } from '~/assets/assetsPath';
import DetailInfoClientSection from '~/components/DetailInfoClientSection';
import DetailInfoServiceSection from '~/components/DetailInfoServiceSection';
import config from '~/config';
import CardAboutMe from '../../components/card-about-me';
import styles from './DetailBooking.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';

const cx = classNames.bind(styles);

const DetailBooking = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { booking_id } = useParams();
    const [bookingInfo, setBookingInfo] = useState({});

    const handleGetBookingInfo = async () => {
        try {
            setIsLoading(true);
            let booking = {};
            const params = {
                fields: '["$all", {"branch": ["$all"]}, {"booking_details": ["$all", {"service": ["$all", {"unit": ["$all"]}]}, {"combo_service": ["$all","$paranoid"]}]}]',
            };
            const res = await historyBookingAPI.getOneHistoryBookingAPI(booking_id, params);

            if (res.code === 200) {
                booking = { ...res.results.object };
            }

            setBookingInfo(booking);
            setIsLoading(false);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        handleGetBookingInfo();
        //eslint-disable-next-line
    }, [booking_id]);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangThongTinLichDat');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                <div className={cx('left_section')}>
                    <div className={cx('left_wrapper')}>
                        <div className={cx('left_container')}>
                            <Row>
                                <CardAboutMe tabIndex={{ parent: 4, children: null }} />
                            </Row>
                        </div>
                    </div>
                </div>
                <div className={cx('right_section')}>
                    <div className={cx('right_container')}>
                        {isLoading ? (
                            <Row justify="center">
                                <Spin />
                            </Row>
                        ) : (
                            <>
                                {bookingInfo?.id ? (
                                    <>
                                        <Row className={cx('nav')}>
                                            <Col xs={8}>
                                                <Row align="middle" className={cx('come_back')}>
                                                    <img
                                                        src={SVGS.IconArrowLeft}
                                                        alt=""
                                                        onClick={() => navigate(config.routes.historyBooking)}
                                                    />
                                                    <span
                                                        className={cx('text')}
                                                        onClick={() => navigate(config.routes.historyBooking)}
                                                    >
                                                        Return
                                                    </span>
                                                </Row>
                                            </Col>
                                            <Col xs={16}>
                                                <Row align="middle" justify="end">
                                                    Schedule code:
                                                    <span className={cx('code_service')}>
                                                        #{bookingInfo.booking_code}
                                                    </span>
                                                </Row>
                                                <Row justify="end">
                                                    {bookingInfo?.activity === 'WAITING' && (
                                                        <span className={cx('status')}>Waiting for confirmation</span>
                                                    )}
                                                    {bookingInfo?.activity === 'PROCESSING' && (
                                                        <span className={cx('status')}>Confirmed</span>
                                                    )}
                                                    {(bookingInfo?.activity === 'ASSIGNED' ||
                                                        bookingInfo?.activity === 'CONFIRMED') && (
                                                        <span className={cx('status')}>Processing</span>
                                                    )}

                                                    {bookingInfo?.activity === 'COMPLETED' && (
                                                        <span className={cx('status')}>Completed</span>
                                                    )}
                                                    {bookingInfo?.activity === 'CANCELED' && (
                                                        <span className={cx('status')}>Canceled</span>
                                                    )}
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Divider style={{ borderTop: '10px solid rgba(0,0,0,.06)' }} />
                                        <DetailInfoClientSection item={bookingInfo} />
                                        <Divider style={{ borderTop: '10px solid rgba(0,0,0,.06)' }} />
                                        <DetailInfoServiceSection
                                            item={bookingInfo}
                                            handleGetBookingInfo={handleGetBookingInfo}
                                        />
                                    </>
                                ) : (
                                    <Row justify="center" className={cx('service_no_exist')}>
                                        Booking schedule does not exist
                                    </Row>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetailBooking;
